module.exports = __webpack_public_path__ + "img/8_l_no.1b5a769b.svg";